// extracted by mini-css-extract-plugin
module.exports = {"bb-hero":"bb-hero__0mMvh"};